import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';

export enum MailModuleActionTypes {
  GetMailModuleList = '[MailModule] Get Mail Module List',
  UpsertMailModuleList = '[MailModule] Upsert Mail Module List',
  GetMailModuleListFail = '[MailModule] Get Mail Module List Fail',
  AddMailModule = '[MailModule] Add Mail Module',
  UpdateMailModule = '[MailModule] Update Mail Module',
  DeleteMailModule = '[MailModule] Delete Mail Module',
}

export class GetMailModuleList implements Action {
  readonly type = MailModuleActionTypes.GetMailModuleList;

  constructor(public payload: any = null) {}
}

export class UpsertMailModuleList implements Action {
  readonly type = MailModuleActionTypes.UpsertMailModuleList;

  constructor(public payload: any = null) {}
}

export class GetMailModuleListFail implements Action {
  readonly type = MailModuleActionTypes.GetMailModuleListFail;
  
  constructor(public payload: any = null) {}
}
export class AddMailModule implements Action {
  readonly type = MailModuleActionTypes.AddMailModule;

  constructor(public payload: any = null) {}
}
export class UpdateMailModule implements Action {
  readonly type = MailModuleActionTypes.UpdateMailModule;

  constructor(public payload: any = null) {}
}
export class DeleteMailModule implements Action {
  readonly type = MailModuleActionTypes.DeleteMailModule;

  constructor(public payload: any = null) {}
}

export type MailModuleActions =
  GetMailModuleList
  | UpsertMailModuleList
  | GetMailModuleListFail
  | AddMailModule
  | UpdateMailModule
  | DeleteMailModule;
